<template>
    <rkm-form
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    :options="data.form"
                    :validations="validations.tipoPrioridadeId"
                    label="Tipo"
                    show-default-option
                    text-field="nome"
                    v-model="model.tipoPrioridadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    :validations="validations.nomePrioridade"
                    label="Nome"
                    v-model="model.nomePrioridade"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>

// Mixins.
import { repository, error, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {

            return {
                nomePrioridade: { required: true, min: 3, max: 100 },
                tipoPrioridadeId: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('manutencao.parametrizacao')
        }

        if (this.prioridade) {

            this.loadPrioridade();
        }
    },
    data: () => ({
        model: {
            id: null,
            nomePrioridade: null,
            tipoPrioridadeId: null,
            tipoPrioridadeNome: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        loadPrioridade() {

            Object.assign(this.model, this.prioridade)
        },
        save() {
            this.$refs.Form.validate()
                .then(valid => {
                    if (!valid) return;

                    if (!this.prioridade) {

                        const prioridadeDuplicada = this.prioridadeJaAdicionada();
                        const nomeDuplicado = this.nomePrioridadeJaAdicionado();

                        if (prioridadeDuplicada && nomeDuplicado) {

                            this.showValidationNotification('A prioridade selecionada e o nome já foram incluídos.');
                            return;
                        } else if (prioridadeDuplicada) {

                            this.showValidationNotification('A prioridade selecionada já foi incluída.');
                            return;
                        } else if (nomeDuplicado) {

                            this.showValidationNotification('O nome da prioridade já foi incluído.');
                            return;
                        }
                    }

                    if (this.prioridade) {

                        Object.assign(this.originalPrioridade, this.prepareData());
                    } else {

                        this.data.model.prioridade.push(this.prepareData());
                    }

                    this.$emit('save');
                });
        },
        prioridadeJaAdicionada() {

            return !!this.data.model.prioridade.find(r => r.tipoPrioridadeId === this.model.tipoPrioridadeId)
        },
        nomePrioridadeJaAdicionado() {

            return !!this.data.model.prioridade.find(r => r.nomePrioridade === this.model.nomePrioridade)
        },
        prepareData() {

            const data = this.clone(this.model)

            data.tipoPrioridadeNome = this.data.form.find(t => t.id === data.tipoPrioridadeId).nome

            return data
        }
    },
    mixins: [repository, error, object],
    props: {
        data: { type: Object, required: true },
        originalPrioridade: { type: Object },
        prioridade: { type: Object },
    },
}
</script>